import { NOTIFICATION_SEND, NOTIFICATION_DISMISS, NOTIFICATION_CLEAR, NOTIFICATION_UPDATE, NOTIFICATION_CLOSE } from '../actions/notifications';
import { notification } from 'antd';

export default function notifications(domain = [], action) {
    if (!action || !action.type) return domain;

    switch (action.type) {
    case NOTIFICATION_SEND:
        return [action.payload, ...domain.filter(({ id }) => id !== action.payload.id)];
    case NOTIFICATION_DISMISS:
        domain.map(notif => {
            if(notif.id === action.payload && notif.closeFn !== undefined){
                notif.closeFn();
            }
            return notif;
        });

        return domain.filter(notif => 
            notif.id !== action.payload
        );
    case NOTIFICATION_CLOSE:
        notification.close(action.payload);

        return domain.filter(notif => 
            notif.id !== action.payload
        );
    case NOTIFICATION_UPDATE:
        return domain.map(notif => {
            if(notif.id === action.payload.id){
                notif.closeFn = action.payload.fn;
            }
            return notif;
        });
    case NOTIFICATION_CLEAR:
        return [];
    default:
        return domain;
    }
}